import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { Form, Message } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';

import ConfigSelect from './ConfigSelect';
import ConfigTable from './ConfigTable';
import CreateConfig from './CreateConfig';
import {
    buildStudyProgramDisplayName,
    buildStudyProgramCycleLabel,
    sortStudyPrograms,
} from './studyProgramUtils';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const PAGINATION_PARAMS = {
    name: '',
    pageNumber: 0,
    resultsPerPage: 1000,
};
// props: manipulateConfig(bool)
export default class DocumentTemplateConfiguration extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            scope: (props.sharedSelection && props.sharedSelection.scope) || 'ou',
            faculty: '',
            studyProgram: '',
            templateConfig: '',
            template: '',

            faculties: [],
            studyPrograms: [],
            templateConfigs: [],
            templates: [],

            attributes: [],
            attributeNames: [],
            availableAttributeNames: [],

            currentName: '',
            currentValue: '',
            currentDisplayName: '',

            addMode: false,
            editId: null,
            promptForNewConfig: false,
            hasFacultyFallbackActive: false,

            error: false,
            errorText: '',
            errorLog: '',
            showMessage: false,

            startDate: new Date(),
            startDateErr: false

        };

        this.onSelectChange = this.onSelectChange.bind(this);
        this.getAttributeName = this.getAttributeName.bind(this);
        this.getAttributeDisplayName = this.getAttributeDisplayName.bind(this);

        this._fetchFaculties = this._fetchFaculties.bind(this);
        this._fetchStudyPrograms = this._fetchStudyPrograms.bind(this);
        this._fetchTemplateConfigurations = this._fetchTemplateConfigurations.bind(this);
        this._checkFacultyFallbackAvailability = this._checkFacultyFallbackAvailability.bind(this);
        this._fetchAttributes = this._fetchAttributes.bind(this);
        this._fetchAttributesNames = this._fetchAttributesNames.bind(this);
        this._updateAvailableAttributesNames = this._updateAvailableAttributesNames.bind(this);
        this._fetchTemplates = this._fetchTemplates.bind(this);
        this._hasNonEmptyValue = this._hasNonEmptyValue.bind(this);

        this._saveNewAttribute = this._saveNewAttribute.bind(this);
        this._deleteAttribute = this._deleteAttribute.bind(this);
        this._saveEditedAttribute = this._saveEditedAttribute.bind(this);
        this.changeStep = this.changeStep.bind(this);
        this.deleteConfig = this.deleteConfig.bind(this);
        this._updateSharedSelection = this._updateSharedSelection.bind(this);

        this.countTemplateConfig = this.countTemplateConfig.bind(this);
    }

    _updateSharedSelection(partialSelection) {
        if (this.props.onSelectionChange) {
            this.props.onSelectionChange(partialSelection);
        }
    }

    componentDidMount() {
        this._fetchFaculties();
        this._fetchTemplates();
        // this._fetchTemplateConfigurations();
        this._fetchAttributes();
    }

    countTemplateConfig(templateConfigs) {
        let tempateIds = [];
        templateConfigs.map(el => (
            tempateIds.push(el.templateId)
        ));
        let uniq = Array.from(new Set(tempateIds));
        if (tempateIds.length !== uniq.length) {
            this.setState({ showMessage: true });
        } else this.setState({ showMessage: false });
    }

    changeStep(toastMess) {
        this.props.changeStep(0);

        if (toastMess) { toast('Konfiguracija je uspješno kreirana.'); }
        // else {
        //     toast('Došlo je do greške! Konfiguracija nije kreirana.');
        // }
        this._fetchTemplateConfigurations();
    }

    deleteConfig(templateConfigurationId) {
        const { scope } = this.state;
        const url = scope === 'sp'
            ? `/template-configuration/use-end/study-program/${templateConfigurationId}`
            : `/template-configuration/use-end/${templateConfigurationId}`;
        axios.post(url)
            .then(() => {
                toast('Arhiviranje konfiguracije je uspješno izvršeno.');
                this._fetchTemplateConfigurations();
            })
            .catch(() => {
                toast('Došlo je do greške! Arhiviranje konfiguracije nije uspjelo.');
            });
    }

    onSelectChange(event, { name, value }) {
        event.preventDefault();
        this.setState({
            [name]: value,
        }, () => {
            if (name === 'scope' || name === 'faculty' || name === 'studyProgram' || name === 'templateConfig' || name === 'template') {
                this._updateSharedSelection({ [name]: value });
            }
            if (name === 'scope') {
                this.setState({
                    templateConfigs: [],
                    templateConfig: '',
                    studyProgram: '',
                    hasFacultyFallbackActive: false,
                }, () => {
                    this._updateSharedSelection({ templateConfig: '', studyProgram: '', scope: value });
                    if (value === 'ou') {
                        this._fetchTemplateConfigurations();
                    } else {
                        this._fetchStudyPrograms();
                    }
                });
            } else if (name === 'faculty') {
                this.setState({
                    templateConfigs: [],
                    templateConfig: '',
                    studyProgram: '',
                    studyPrograms: [],
                    hasFacultyFallbackActive: false,
                }, () => {
                    this._updateSharedSelection({ templateConfig: '', studyProgram: '' });
                    if (this.state.scope === 'sp') {
                        this._fetchStudyPrograms();
                    } else {
                        this._fetchTemplateConfigurations();
                    }
                });
            } else if (name === 'studyProgram') {
                this._fetchTemplateConfigurations();
            } else if (name === 'templateConfig') {
                this._fetchAttributes();
            }
        });
    }

    getAttributeName(id) {
        const { attributeNames } = this.state;
        const selected = attributeNames.find(el => el.id === id);
        if (selected && selected.name) return selected.name;
        return '';
    }

    getAttributeDisplayName(id) {
        const { attributeNames } = this.state;
        const selected = attributeNames.find(el => el.id === id);
        if (selected && selected.displayName) return selected.displayName;
        return '';
    }

    _fetchFaculties() {
        axios.get('/graduation-documents/faculties')
            .then(res => {
                const faculties = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                if (faculties.length === 0) {
                    this.setState({ error: true, errorText: 'faculties list was empty' });
                } else {
                    const sharedFaculty = this.props.sharedSelection && this.props.sharedSelection.faculty;
                    const sharedScope = (this.props.sharedSelection && this.props.sharedSelection.scope) || 'ou';
                    const sharedStudyProgram = (this.props.sharedSelection && this.props.sharedSelection.studyProgram) || '';
                    const hasSharedFaculty = faculties.some(item => item.id === sharedFaculty);
                    const selectedFaculty = hasSharedFaculty ? sharedFaculty : faculties[0].id;
                    this.setState({
                        faculties,
                        faculty: selectedFaculty,
                        scope: sharedScope,
                        studyProgram: sharedStudyProgram,
                    }, () => {
                        this._updateSharedSelection({ faculty: selectedFaculty });
                        if (sharedScope === 'sp') {
                            this._fetchStudyPrograms();
                        } else {
                            this._fetchTemplateConfigurations();
                        }
                    });
                }
            })
            .catch(error => this.setState({ error, errorText: 'failed to fetch faculties' }));
    }

    _fetchStudyPrograms() {
        const { faculty } = this.state;
        if (!faculty) return;
        axios.get(`/template-configuration/study-programs/${faculty}`)
            .then(res => {
                const studyPrograms = sortStudyPrograms(res.data).map(el => ({
                    ...el,
                    key: el.id,
                    value: el.id,
                    text: buildStudyProgramDisplayName(el),
                    description: buildStudyProgramCycleLabel(el),
                    title: el.studyProgramDescription || el.description || '',
                }));
                const sharedStudyProgram = this.props.sharedSelection && this.props.sharedSelection.studyProgram;
                const hasShared = studyPrograms.some(sp => sp.id === sharedStudyProgram);
                const selected = hasShared ? sharedStudyProgram : (studyPrograms[0] ? studyPrograms[0].id : '');
                this.setState({ studyPrograms, studyProgram: selected }, () => {
                    this._updateSharedSelection({ studyProgram: selected });
                    if (selected) this._fetchTemplateConfigurations();
                });
            })
            .catch(() => this.setState({ studyPrograms: [] }));
    }


    _checkFacultyFallbackAvailability() {
        const { faculty, scope } = this.state;
        if (this.props.studentService || scope !== 'sp' || !faculty) {
            this.setState({ hasFacultyFallbackActive: false });
            return;
        }

        axios.get(`template-configuration/templates/${faculty}`)
            .then(res => {
                const hasActiveFacultyConfig = res.data.some(el => el.useEnd === null);
                this.setState({ hasFacultyFallbackActive: hasActiveFacultyConfig });
            })
            .catch(() => this.setState({ hasFacultyFallbackActive: false }));
    }

    _hasNonEmptyValue(value) {
        return value !== null && value !== undefined && String(value).trim() !== '';
    }

    // TODO: if prop manipulateConfig exists fetch all LKP_document_templates
    _fetchTemplateConfigurations() {
        const { faculty, scope, studyProgram } = this.state;
        let url;
        if (this.props.studentService) {
            url = 'template-configuration/templates';
        } else if (scope === 'sp') {
            if (!studyProgram) return;
            url = `template-configuration/templates/study-program/${studyProgram}`;
        } else {
            url = `template-configuration/templates/${faculty}`;
        }
        axios.get(url)
            .then(res => {
                let templateConfigs = res.data.sort((a, b) => b.templateId - a.templateId).map(el => ({
                    ...el,
                    key: el.templateConfigurationId,
                    value: el.templateConfigurationId,
                    text: el.useEnd ? el.name + ' (' + moment(el.useStart).format('D. M. YYYY.') + ' - ' + moment(el.useEnd).format('D. M. YYYY.') + ')'
                        : el.name + ' (' + moment(el.useStart).format('D. M. YYYY.') + ' - danas)'
                }));
                this.countTemplateConfig(templateConfigs);
                if (templateConfigs.length === 0) {
                    this.setState({ promptForNewConfig: true });
                    this.setState({ templateConfigs: [], templateConfig: '' });
                    this._updateSharedSelection({ templateConfig: '' });
                    this._checkFacultyFallbackAvailability();
                } else {
                    const sharedTemplateConfig = this.props.sharedSelection && this.props.sharedSelection.templateConfig;
                    const hasSharedTemplateConfig = templateConfigs.some(item => item.value === sharedTemplateConfig);
                    const activeTemplateConfig = templateConfigs.filter(el => el.useEnd === null)[0];
                    const selectedTemplateConfig = hasSharedTemplateConfig
                        ? sharedTemplateConfig
                        : (activeTemplateConfig ? activeTemplateConfig.value : '');
                    this.setState({
                        templateConfigs,
                        templateConfig: selectedTemplateConfig,
                        hasFacultyFallbackActive: false,
                    }, () => {
                        this._updateSharedSelection({ templateConfig: selectedTemplateConfig });
                    });
                }
            })
            .catch(err => this.setState({ error: true, errorText: 'failed to fetch config templates', errorLog: err.message }));
    }
    _fetchAttributes() {
        if (this.state.templateConfigs.length === 0) return;
        const selectedTemplateConfigId = Number(this.state.templateConfig);
        const selectedTemplateConfig = this.state.templateConfigs.find(el => el.templateConfigurationId === selectedTemplateConfigId);
        if (!selectedTemplateConfig) return;
        const { templateId, templateConfigurationId } = selectedTemplateConfig;
        axios.get(`/template-configuration/attributes/${templateConfigurationId}/${templateId}`)
            .then(res => {
                const attributes = res.data;
                this.setState({ attributes }, () => this._fetchAttributesNames());
            })
            .catch(() => console.log(`failed to fetch attributes for template ${templateId} and templateConfig ${templateConfigurationId}`));
    }
    _fetchAttributesNames() {
        // get template id
        const selectedTemplateConfigId = Number(this.state.templateConfig);
        const selectedTemplateConfiguration = this.state.templateConfigs.find(el => el.templateConfigurationId === selectedTemplateConfigId);
        if (!selectedTemplateConfiguration) {
            this.setState({ attributeNames: [], availableAttributeNames: [] });
            return;
        }
        const { templateId } = selectedTemplateConfiguration;

        axios.get(`template-configuration/attributes/${templateId}`)
            .then(res => {
                const attributeNames = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.displayName
                }));
                this.setState({
                    attributeNames
                }, () => this._updateAvailableAttributesNames());
            });
    }
    _updateAvailableAttributesNames() {
        const { attributeNames, attributes } = this.state;
        const usedAttributeNames = new Set(attributes.map(el => el.name));
        const available = attributeNames.filter(el => !usedAttributeNames.has(el.name));

        let allAttributeKeys = available.sort().reduce((accumulator, current) => {
            const dataLength = accumulator.length;
            if (dataLength === 0 || accumulator[dataLength - 1] !== current.key) {
                accumulator.push(current.key);
            }
            return accumulator;
        }, []);

        const uniqueAttributeKeys = allAttributeKeys.filter((val, id, array) => array.indexOf(val) === id);

        const availableAttributes = uniqueAttributeKeys.map(el => ({
            key: el,
            value: el,
            text: this.getAttributeDisplayName(el),
            name: this.getAttributeName(el),
            attributeType: (attributeNames.find(attr => attr.id === el) || {}).attributeType,
            translatable: (attributeNames.find(attr => attr.id === el) || {}).translatable,
        }));

        this.setState({ availableAttributeNames: availableAttributes });
    }
    _saveNewAttribute(name, displayName, value, engValue) {
        const hasEnglishValue = this._hasNonEmptyValue(engValue);
        const newAttribute = {
            name,
            displayName,
            value,
            translations: hasEnglishValue ? [{ language: { twoLetterCode: 'en' }, value: engValue }] : null
        };
        const selectedTemplateConfigId = Number(this.state.templateConfig);
        const selectedTemplateConfiguration = this.state.templateConfigs.find(el => el.templateConfigurationId === selectedTemplateConfigId);
        if (!selectedTemplateConfiguration) return;
        const { templateId, templateConfigurationId } = selectedTemplateConfiguration;
        axios.post(`/template-configuration/attributes/${templateConfigurationId}/${templateId}`, { ...newAttribute })
            .then(() => this._fetchAttributes())
            .catch(() => console.log('could not save new attribute'));
    }
    _saveEditedAttribute(id, name, displayName, value, engValue) {
        // const selectedTemplateConfiguration = this.state.templateConfigs.find(el => el.templateConfigurationId == this.state.templateConfig);
        // const { templateId, templateConfigurationId } = selectedTemplateConfiguration;

        const hasEnglishValue = this._hasNonEmptyValue(engValue);
        let translations = [{ language: { twoLetterCode: 'en' }, value: engValue }];
        const attributeToUpdate = {
            id, name, displayName, value, translations: hasEnglishValue ? translations : null
        };
        axios.put('/template-configuration/attributes', { ...attributeToUpdate })
            .then(() => this._fetchAttributes())
            .catch(() => console.log('could not udpate existing attribute'));
    }
    _deleteAttribute(id) {
        axios.delete(`/template-configuration/attributes/${id}`)
            .then(() => this._fetchAttributes())
            .catch(() => console.log('could not delete attribute'));
    }
    _fetchTemplates() {
        axios.get('document-templates', { params: PAGINATION_PARAMS })
            .then(res => {
                const allTemplates = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.documentType.name
                }));
                const templatesAdmin = allTemplates.filter(el =>
                    el.name === 'degree' || el.name === 'degree_supplement');
                const templatesSService = allTemplates.filter(el =>
                    el.name !== 'degree' && el.name !== 'degree_supplement' && el.name !== 'degree_english' && el.name !== 'credentials_report' && el.name !== 'student_graded_activity_report'
                    && el.name !== 'exam_application' && el.name !== 'exam_marks_report' && el.name !== 'professor_workload_report' && el.name !== 'ou_workload_report'
                    && el.name !== 'assistant_workload_report' && el.name !== 'ou_questionnaire_statistics' && el.name !== 'student_course_implementation'
                    && el.name !== 'exam_marks_without_full_name_report' && el.name !== 'personal_questionnaire_statistics');
                const templates = this.props.studentService ? templatesSService : templatesAdmin;
                const sharedTemplate = this.props.sharedSelection && this.props.sharedSelection.template;
                const hasSharedTemplate = templates.some(item => item.id === sharedTemplate);
                const selectedTemplate = hasSharedTemplate ? sharedTemplate : (templates[0] ? templates[0].id : '');
                this.setState({ templates, template: selectedTemplate });
                this._updateSharedSelection({ template: selectedTemplate });
            });
    }
    // if manipulateConfig exists in props dont render table but instead render input fields
    // for new config with data dateStart (default today) and dateEnd (default null)
    // checkbox active (default false)

    render() {
        const {
            scope, faculty, studyProgram, studyPrograms, faculties,
            templateConfig, templateConfigs, templates, template,
            hasFacultyFallbackActive,
        } = this.state;
        const showInheritanceHint = !this.props.studentService && scope === 'sp';
        const emptyScopeLabel = scope === 'sp' ? 'studijski program' : 'fakultet';
        const errorNoTemplate = (
            <Message info>
                <Message.Header>Nema aktivnih verzija dokumenta</Message.Header>
                <p>
                    Za odabrani {emptyScopeLabel} trenutno ne postoji aktivna konfiguracija.
                    {' '}Dodajte novu konfiguraciju u tabu Kreiranje.
                </p>
            </Message>
        );

        const scopeOptions = [
            { key: 'ou', value: 'ou', text: 'Nivo fakulteta' },
            { key: 'sp', value: 'sp', text: 'Nivo studijskog programa' },
        ];

        const selects = (
            <div>
                <Form>
                    {!this.props.studentService && <ConfigSelect
                        name="scope"
                        colWidth={12}
                        simpleName="Nivo konfiguracije"
                        value={scope}
                        data={scopeOptions}
                        onChange={this.onSelectChange}
                    />}
                    {!this.props.studentService && !this.props.manipulateConfig && <ConfigSelect
                        name="faculty"
                        colWidth={12}
                        simpleName="Fakultet"
                        value={faculty}
                        data={faculties}
                        onChange={this.onSelectChange}
                    />}
                    {!this.props.studentService && scope === 'sp' && <ConfigSelect
                        name="studyProgram"
                        colWidth={12}
                        simpleName="Studijski program"
                        value={studyProgram}
                        data={studyPrograms}
                        onChange={this.onSelectChange}
                    />}
                    {!this.props.manipulateConfig &&
                    <ConfigSelect
                        name="templateConfig"
                        simpleName="Verzija dokumenta"
                        value={templateConfig}
                        data={this.props.studentService ? templateConfigs.filter(el => el.name !== 'Dodatak diplomi' && el.name !== 'Diploma' && el.name !== 'Pristupni podaci' && el.useEnd === null) : templateConfigs.filter(el => el.useEnd === null)}
                        onChange={this.onSelectChange}
                        idName="templateConfigurationId"
                        transformDisplayNameWithDate
                    />
                    }
                </Form>
                {showInheritanceHint && <Message size="small" info>
                    Ako za odabrani studijski program nema aktivne konfiguracije, koristi se konfiguracija organizacione jedinice tokom generisanja dokumenata.
                </Message>}
                <br />

                {this.props.manipulateConfig ? <CreateConfig
                    scope={scope}
                    faculty={faculty}
                    studyProgram={studyProgram}
                    hasFacultyFallbackActive={hasFacultyFallbackActive}
                    template={template}
                    studentService={this.props.studentService}
                    changeStep={this.changeStep}
                    templateConfigs={templateConfigs}
                    name="template"
                    simpleName="Tip dokumenta"
                    value={template}
                    data={templates}
                    onChange={this.onSelectChange}
                    idName="id"
                    nameF="faculty"
                    simpleNameF="Fakultet"
                    valueF={faculty}
                    dataF={faculties}
                    onChangeF={this.onSelectChange}
                    deleteConfig={this.deleteConfig}
                />
                    : templateConfig === '' ?
                        errorNoTemplate
                        : <ConfigTable
                            studentService={this.props.studentService}
                            attributes={this.state.attributes}
                            attributeNames={this.state.attributeNames}
                            availableAttributeNames={this.state.availableAttributeNames}
                            saveNewAttribute={this._saveNewAttribute}
                            saveEditedAttribute={this._saveEditedAttribute}
                            deleteAttribute={this._deleteAttribute}
                            fetchAttributes={this._fetchAttributes}
                            fetchAttributesNames={this._fetchAttributesNames}
                        />}
            </div>
        );

        return (
            <div>
                {selects}
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DocumentTemplateConfiguration/DocumentTemplateConfiguration.js